import Step1Image from '../../../assets/images/welcome/step1.webp';
import Step2Image from '../../../assets/images/welcome/step2.webp';
import Step3Image from '../../../assets/images/welcome/step3.webp';
import Step4Image from '../../../assets/images/welcome/step4.webp';

export const steps = [
  {
    key: 'step1',
    image: Step1Image,
    usedKey: ['title', 'description', 'button'],
    link: '/settings/Product_Discovery',
  },
  {
    key: 'step2',
    image: Step2Image,
    usedKey: ['title', 'description', 'moreInfo'],
  },
  {
    key: 'step3',
    image: Step3Image,
    usedKey: ['title', 'description', 'description2'],
  },
  {
    key: 'step4',
    image: Step4Image,
    usedKey: ['title', 'description'],
  },
];
